"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnstyledButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _buttonResetMixin = require("../buttonResetMixin");
var _focusMixin = require("../focusMixin");
var UnstyledButtonMixin = /*#__PURE__*/(0, _styledComponents.css)(["", " ", ""], _buttonResetMixin.buttonResetMixin, _focusMixin.focusMixin);
exports.UnstyledButtonMixin = UnstyledButtonMixin;